import React from 'react';
import MeetingMemberAlerts from './meetingMemberAlerts';
import {
  WbMarkdownHtml, 
} from '../../utils/common';
import { withTranslation } from "react-i18next";

// Header Left section
class MeetingTopHeaderLeft extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showDescEdit: false,
      tempName: '',
    };
    this.saveMeeting = this.saveMeeting.bind(this);
    this.keypressMeeting = this.keypressMeeting.bind(this);
    this.editDesc = this.editDesc.bind(this);
    this.clickEvent = this.clickEvent.bind(this);
  }

  componentDidMount() {
    window.addEventListener('click', this.clickEvent, true);
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.clickEvent, true);
  }

  saveMeeting() {
    const _this = this;
    const meetingName = $(_this.refs.groupMeetingSave).val();
    if (!meetingName || meetingName == '') {
      return false;
    }
    // adding a more reliable way to track click vs drag (mousedown/mouseup)
    let highlightedText = "";
    if (window.getSelection) {
        highlightedText = window.getSelection().toString();
    } 
    else if (document.selection && document.selection.type != "Control") {
        highlightedText = document.selection.createRange().text;
    }
    if (highlightedText != "") {
      return;
    } else {
      this.setState({
        showDescEdit: false,
        tempName: meetingName,
      });
      $.post(`${wbConfig.baseUrl}/meeting/updateMeetingName`, { meetingName, id: this.props.selectedUser.meeting.id }, (response) => {
        if (response.status == 'ok') {
          _this.props.updateMeetingName(meetingName);
          _this.setState({ tempName: '' });
        }
      });
    }
  }

  keypressMeeting(e) {
    if (e.keyCode == 13 && e.shiftKey == false) {
      this.saveMeeting();
    }
  }

  editDesc() {
    this.setState({
      showDescEdit: true,
    });
    setTimeout(() => {
      $('.member-content input.grp-meeting-edit').trigger('focus');
    }, 10);
  }

  clickEvent(e) {
    // adding a more reliable way to track click vs drag (mousedown/mouseup) 
    let highlightedText = "";
    if (window.getSelection) {
        highlightedText = window.getSelection().toString();
    } 
    else if (document.selection && document.selection.type != "Control") {
        highlightedText = document.selection.createRange().text;
    }
    if (highlightedText != "") {
      return;
    } else {
      if (!$('.grp-meeting-edit').is(e.target) // if the target of the click isn't the container...
      && $('.grp-meeting-edit').has(e.target).length === 0) {
        this.setState({
          showDescEdit: false,
        });
      }
    }
  }

  urlify(text) {
		if (text && typeof text !== 'undefined' && text.length > 0) {
			const urlRegex = /((http|https|ftp):\/\/[\w?=&.\/-;#~%-]+(?![\w\s?&.\/;#~%"=-]*>))/g;
			return text.replace(urlRegex, "<a href='$1' target='_blank'>$1</a>");
		}
		return text;
	}

  render() {
    const { t } = this.props;
    const selectedUserDet = this.props.selectedUser;
    const meetingText = (selectedUserDet.meeting.type == 1) ? '1on1 with' : '';
    const userImage = (selectedUserDet.meeting.type == 1);

    let titleText = '';
    if (selectedUserDet.meeting.type == 1) {
      titleText = selectedUserDet.selectedUser.title;
    } else {
      titleText = selectedUserDet.meeting.location;
    }

    let meetingName = this.props.selectedUser.meeting.type == 1 ? this.props.selectedUser.selectedUser.fullName : this.props.selectedUser.meeting.name;
    if (this.state.tempName) {
      meetingName = this.state.tempName;
    }

    const { userPermission } = selectedUserDet;
    const { showDescEdit } = this.state;

    return (
      <div className="meeting1on1-user-wrapper">
        <div>
          {
            userImage
            && (
            <div className="member-img oneonone-member-img teamMeetingInviteeImgDiv left" data-member-id={selectedUserDet.selectedUser.id}>
              <img src={selectedUserDet.selectedUser.picture} className="memberPic" width="35" height="35" />
            </div>
            )
          }

          <div className="left member-content">
            <div>
              {
                !(showDescEdit) && (userPermission.meetingAccess && selectedUserDet.meeting.type != 1 && selectedUserDet.meeting.status == 1
                  ? (
                    <div className="font14 left userFirstname cursorPointer" onClick={this.editDesc}>
                      {meetingText}
                      {' '}
                      {meetingName}
                    </div>
                  )
                  : (
                    <div className="font14 left userFirstname">
                      {meetingText}
                      {' '}
                      {meetingName}
                    </div>
                  ))
              }
              {
                showDescEdit
                    && (
                    <input
                      type="text"
                      placeholder={t("Meeting Name")}
                      ref="groupMeetingSave"
                      className="grp-meeting-edit"
                      onBlur={event => this.saveMeeting(event)}
                      defaultValue={meetingName}
                      onKeyDown={e => this.keypressMeeting(e)}
                    />
                    )
              }
              <div className="clear" />
            </div>

            <div className="member-designation truncateText">
              {' '}
              <div title={titleText} dangerouslySetInnerHTML={WbMarkdownHtml(this.urlify(titleText))} />
            </div>

            {
              selectedUserDet.meeting.type == '1' ? (
                <MeetingMemberAlerts
                  membersAlerts={selectedUserDet.membersAlerts || {}}
                  userPermission={selectedUserDet.userPermission}
                  selectedUser={selectedUserDet.selectedUser}
                />
              ) : ''
            }
          </div>
          <div className="clear" />
        </div>
      </div>
    );
  }
}
export default withTranslation()(MeetingTopHeaderLeft);
